import { render, staticRenderFns } from "./ZJDHS.vue?vue&type=template&id=6f27704a&scoped=true&"
import script from "./ZJDHS.vue?vue&type=script&lang=js&"
export * from "./ZJDHS.vue?vue&type=script&lang=js&"
import style0 from "./ZJDHS.vue?vue&type=style&index=0&id=6f27704a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f27704a",
  null
  
)

export default component.exports